module.exports = __webpack_public_path__ + "65a1022af4c798527c14a370ef3eea3c.png";